import isMobile from 'ismobilejs';

export default {
  computed: {
    isMobile() {
      return isMobile().phone
    }
  }
}